import { getAPI } from "./Networking";

export default class WarehouseAPI {
  searchWarehouse = async (city_id?: number | undefined | null) => {
    try {
      const response = await getAPI(`/v5/inventories/warehouses`, {
        city_id: city_id,
      });
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  searchWarehouseRack = async (warehouse_id: string, search_text: string) => {
    try {
      const response = await getAPI(
        `/v5/inventories/warehouse/racks?search_text=${search_text}&warehouse_id=${warehouse_id}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
